export default __webpack_public_path__ + "static/media/NunitoSans-LightItalic.5a61ddb8.woff";